import { createFileRoute } from '@tanstack/react-router'
import PhoneConfigTab from '@/components/organisms/PhoneConfigTab'

export const Route = createFileRoute('/_authenticated/phone/config')({
  component: PhoneConfigTab,
})
